// src/helpers/save-search-query-temp.js

import PermanentStore from './permanent-store'

const KEY = "gambaApp.savedSearchQuery"
export default PermanentStore(KEY)



// WEBPACK FOOTER //
// ./src/actions/save-search-query-temp.js